// extracted by mini-css-extract-plugin
export default {"trees-container":"TreesContainer-module__trees-container___EHXwy"};